import styled from "styled-components";
import { Table } from "semantic-ui-react";

export const SemanticTable = styled(Table)`
  border-collapse: collapse;
  margin-top: 2em;
  font-size: 1em;

  th {
    padding: 1em;
  }

  tbody {
    tr {
      /* font-size: 14; */
      /* font-family: sans-serif; */
      /* text-align: left; */

      td {
        padding: 15px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      td:first-child {
        max-width: 120px;
      }
      td:nth-child(3) {
        max-width: 160px;
      }
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const CupomAndamento = styled.div`
  display: flex;
`;

export const CupomAndamentoInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  border: 2px solid black;

  width: 25%;

  :nth-child(2) {
    border-left: 0;
    border-right: 0;
  }
  :nth-child(3) {
    border-right: 0;
  }
`;

export const CupomAndamentoTitle = styled.div`
  padding: 8px 0px;

  font-weight: bold;
  text-align: center;
`;

export const CupomAndamentoDescription = styled.div`
  padding: 5px;
  width: 70%;

  text-align: center;
  font-weight: bold;
  color: orange;
`;
